import { render, staticRenderFns } from "./Rating.vue?vue&type=template&id=2ab3ae28&scoped=true&"
import script from "./Rating.vue?vue&type=script&lang=ts&"
export * from "./Rating.vue?vue&type=script&lang=ts&"
import style0 from "./Rating.vue?vue&type=style&index=0&id=2ab3ae28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab3ae28",
  null
  
)

export default component.exports